import React from 'react';
import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSmall from '../../components/Footers/FooterSmall.js';
import ForgotPWComponent from '../../components/Auth/forgot.js';
import Head from 'next/head';

export default function Auth() {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href="https://musicart.io/auth/forgot" />
      </Head>

      <Navbar transparent />
      <main className="main auth_bg">
        <ForgotPWComponent />
      </main>
      <Footer />
      <FooterSmall />
    </>
  );
}
